// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Mensaje test Match con el snapshot 1`] = `""`;
